export default __webpack_public_path__ + "static/media/EngineeringCanals_02.333df4fb.png";